/**
 * @name EmailConfirmation
 *
 * @description
 * Service taking care of email confirmation flag state.
 */
class EmailConfirmation {

    constructor() {
        this.isEmailConfirmationFlagChecked = false;
    }

    setEmailConfirmationFlag(isChecked) {
        this.isEmailConfirmationFlagChecked = isChecked;
    }

    swapEmailConfirmationFlag() {
        this.isEmailConfirmationFlagChecked = !this.isEmailConfirmationFlagChecked;
    }

    isEmailConfirmationChecked() {
        return this.isEmailConfirmationFlagChecked;
    }

}

angular
    .module('BBPublicBooking')
    .service('EmailConfirmationService', EmailConfirmation);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/email-confirmation-checkbox/bb_email_confirmation.service.js